import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Spinner,
  Badge,
  Pagination,
  PaginationItem,
  PaginationLink,
  Button,
} from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { get } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const UserListings = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  document.title = "Anunțurile Utilizatorului | PagaSunt Admin";

  const [loading, setLoading] = useState(true);
  const [listings, setListings] = useState([]);
  const [meta, setMeta] = useState({});
  const [user, setUser] = useState(null);
  const [page, setPage] = useState(1);

  const fetchListings = async () => {
    setLoading(true);
    try {
      const response = await get(`/admin/users/${id}/listings?page=${page}`);
      if (response.status === "success") {
        setListings(response.data.data || []);
        setMeta(response.data || {});
        setUser(response.user || null);
      }
    } catch (error) {
      console.error("Eroare la încărcarea anunțurilor utilizatorului:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchListings();
  }, [id, page]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Utilizatori" breadcrumbItem="Anunțurile Utilizatorului" />

          <Row className="mb-3">
            <Col className="d-flex justify-content-between align-items-center">
              <div>
                <h5 className="mb-0">{user?.name || "Utilizator"}</h5>
                <small className="text-muted">
                  {user?.email || "-"} {user?.phone ? `• ${user.phone}` : ""}
                </small>
              </div>
              <Button color="light" onClick={() => navigate(-1)} className="btn-label">
                <i className="uil uil-arrow-left label-icon"></i> Înapoi
              </Button>
            </Col>
          </Row>

          <Card>
            <CardBody>
              {loading ? (
                <div className="text-center p-5"><Spinner color="primary" /></div>
              ) : (
                <div className="table-responsive">
                  <Table className="table-centered table-nowrap mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>ID</th>
                        <th>Titlu</th>
                        <th>Categorii</th>
                        <th>Preț</th>
                        <th>Plată</th>
                        <th>Status</th>
                        <th>Data</th>
                        <th>Acțiuni</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listings.length > 0 ? (
                        listings.map(listing => (
                          <tr key={listing.id}>
                            <td>#{listing.id}</td>
                            <td style={{ maxWidth: 280 }}>
                              <div className="fw-bold text-truncate">{listing.title}</div>
                            </td>
                            <td>
                              {(listing.categories || []).map(category => (
                                <Badge key={category.id} color="light" className="me-1 text-dark">
                                  {category.name}
                                </Badge>
                              ))}
                            </td>
                            <td>{listing.price} {listing.currency}</td>
                            <td>
                              <Badge color={listing.payment_status === "paid" ? "success" : "danger"}>
                                {listing.payment_status}
                              </Badge>
                            </td>
                            <td>
                              <Badge color={listing.status === "active" ? "primary" : "warning"}>
                                {listing.status}
                              </Badge>
                            </td>
                            <td>{new Date(listing.created_at).toLocaleDateString("ro-RO")}</td>
                            <td>
                              <Link
                                to={`/edit-anunt/${listing.id}`}
                                className="btn btn-sm btn-soft-primary"
                                title="Editează Anunț"
                              >
                                <i className="uil uil-edit-alt"></i>
                              </Link>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center text-muted py-4">
                            Acest utilizator nu are anunțuri.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>

                  {meta.last_page > 1 && (
                    <div className="mt-4 d-flex justify-content-center">
                      <Pagination>
                        <PaginationItem disabled={meta.current_page === 1}>
                          <PaginationLink previous onClick={() => setPage(meta.current_page - 1)} />
                        </PaginationItem>
                        {[...Array(meta.last_page)].map((_, i) => (
                          <PaginationItem active={i + 1 === meta.current_page} key={i}>
                            <PaginationLink onClick={() => setPage(i + 1)}>{i + 1}</PaginationLink>
                          </PaginationItem>
                        ))}
                        <PaginationItem disabled={meta.current_page === meta.last_page}>
                          <PaginationLink next onClick={() => setPage(meta.current_page + 1)} />
                        </PaginationItem>
                      </Pagination>
                    </div>
                  )}
                </div>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserListings;
